import { render, staticRenderFns } from "./Activity2.vue?vue&type=template&id=3d18ca36"
import script from "./Activity2.vue?vue&type=script&lang=js"
export * from "./Activity2.vue?vue&type=script&lang=js"
import style0 from "./Activity2.vue?vue&type=style&index=0&id=3d18ca36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports